function Trending() {
  return (
    <div style={{marginTop:'100px', marginLeft:'50px', marginRight:'50px'}}>
      <div style={{display: 'flex', alignItems: 'center'}}>
        {/* Image Section */}
        <div style={{ 
          flex: '0 0 50%',
          maxWidth: '50%'
        }}>
          <p style={{color:"yellow", fontSize:'28px', marginBottom: '30px'}}>
            Most Trending Drama of 2026
          </p>
          <img 
            src="https://imagesforkdrama.s3.ap-south-1.amazonaws.com/imagesKdrama/canThisLoveBeTranslated.jpeg"
            alt="can this love be translated"
            style={{ 
              width: "80%", 
              height: "60%",
              borderRadius: '12px',
              boxShadow: '0 8px 24px rgba(0,0,0,0.3)'
            }} 
          />
        </div>

        {/* Review Section */}
        <div style={{
          flex: '1',
          padding: '30px',
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '12px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)'
        }}>
          <h3 style={{
            color: '#FFD700',
            fontSize: '24px',
            marginBottom: '20px',
            fontWeight: '600'
          }}>
            Review
          </h3>
          <p style={{
            color: '#E0E0E0',
            fontSize: '16px',
            lineHeight: '1.8',
            marginBottom: '15px'
          }}>
             The cinematography in this series is breathtaking, with stunning scenes filmed across Japan, Canada, and Italy.
            This slow-burning romance captivates with its beautiful moments and meaningful dialogue.
            The chemistry between the leads is truly magical, and the entire cast delivers exceptional performances.
             This is a must-watch that's impossible to resist binge-watching—you won't be able to stop at just one episode!
                 

          </p>
          <div style={{
            marginTop: '20px',
            paddingTop: '20px',
            borderTop: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <span style={{color: '#FFD700', fontSize: '18px'}}>⭐⭐⭐⭐⭐</span>
            <span style={{color: '#B0B0B0', marginLeft: '10px', fontSize: '14px'}}>
              4.8/5
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Trending;